const compareByDepth = (a, b) => a.depth - b.depth;
export { compareByDepth };